module.exports = __webpack_public_path__ + "static/media/Leaf_icon_15.859f4fc4.svg";